import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';

import StatusMessage from '../../util/StatusMessage'
import PaginationComponent from '../PaginationComponent';
import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Select } from 'rmwc/Select';
import ReactExport from "react-data-export";

class AdminHallTicketDetails extends Component {

  constructor(props) {
    super(props);
    this.state={
      hallTicketDetails: [],
      errorMsg: '',
      itemsPerPage: 200,
      totalCount: '',
      criteria: '',
      searchTerm: '',
      searchDetail: false,
      searchErrorMsg: '',
      searchHit: 0,
      data: {
        exportPage: 1,
        exportItemsPerPage: 5000,

      },
      downloadDisable: true,
      hallticketDownloadDisable: false
    }
    this.fetchHallTicketDetails = this.fetchHallTicketDetails.bind(this);
  }

  componentDidMount() {
    return api.getHallTicketDetails(this.props.user.accessToken,1,this.state.itemsPerPage)
    .then((result) => {
      console.log(result)
      if(result.status === 'success'){
        this.setState({
          hallTicketDetails: result.data,
          totalCount: result.total_count
        })
      }
      else {
        this.setState({
          errorMsg: result.data
        })
      }
    })
  }

  fetchHallTicketDetails = (pageNo) => {
    this.retrieveDetails(pageNo,this.state.searchDetail, this.state.searchHit)
  }

  retrieveDetails = (pageNo,isSearch,searchHit) => {
    let hallTicketDetails = []
    let totalCount
    let apiInput = {'criteria_key': this.state.criteria,
      "criteria_val": this.state.searchTerm,
      "items_per_page": this.state.itemsPerPage,
      "page_no": pageNo
    }
    console.log(isSearch)
    if(isSearch) {
      api.searchHallTicketDetails(this.props.user.accessToken, apiInput)
      .then((result) => {
        if (result.status === 'success'){
          hallTicketDetails = result.data
          totalCount = result.total_count
          this.setState({hallTicketDetails: hallTicketDetails, totalCount: totalCount, searchResource: true, searchHit:searchHit, searchDetail:true})
        }
        else{
          this.setState({searchDetail:true})
        }
      })
    }
    else {
      let empty_arr =[]
      return api.getHallTicketDetails(this.props.user.accessToken,pageNo,this.state.itemsPerPage)
      .then((result) => {
        console.log(result)
        if(result.status === 'success'){
          this.setState({
            hallTicketDetails: result.data,
            totalCount: result.total_count,
            searchHit:0,
            searchDetail:false
          })
        }
        else {
          
          this.setState({
            hallTicketDetails: empty_arr,
            errorMsg: result.data,
            searchHit:0,
            searchDetail:false
          })
        }
      })
      .catch((err) => {
        console.log("inside exception get all details")
        this.setState({ errorMsg: 'Error in Retrieving data', searchHit:0, searchDetail:false})
      })
    }
  }

  handleUpdateHallTicketDetails = (e, hallTicketId, userId) => {
    e.preventDefault();
    this.props.history.push(`/portal/app/admin/hallticket/update/${hallTicketId}/${userId}`)
  }

  onInputChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  handleSearchCriteriaChange = (e) => {
    this.setState({criteria: e.target.value})
  }

  handleSearchQuery = (e) => {
    if(this.state.searchTerm === ''){
      this.setState({searchErrorMsg: 'Search field should not be empty'})
      return
    }
    e.preventDefault()
    let searchHit = this.state.searchHit+1
    this.retrieveDetails(1,true, searchHit);
    
  }

  handleClear = (e) => {
    e.preventDefault()
    this.setState({searchTerm: '',criteria: ''})
    this.retrieveDetails(1,false,0)
  }

  onExportInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handleExportData = e => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    if(!this.state.downloadDisable){
      this.setState({downloadDisable: true})
    }
    api.getHallTicketDetails(this.props.user.accessToken, data.exportPage, data.exportItemsPerPage).then((result) => {
      const { status, errors} = result
        if (status === 'success') {
          data.exportData = result.data
          this.setState({data:data, downloadDisable: false})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Error in Fetching Details', downloadDisable: true })
      })
  }

  handleHallTicketDownload = (e, hallticketId) => {

    e.preventDefault()
    let hallTicketId = hallticketId + ".pdf"
    this.setState({hallticketDownloadDisable: true})
    api.downloadHallticket(this.props.user.accessToken, hallTicketId)
      .then((result) => {
        if (result instanceof Blob){
          this.setState({errorMsg: '', hallticketDownloadDisable: false })
          
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'hallticket.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({ errorMsg: 'Unable to download hallticket. Please contact Administrator'})
          
        }  
    })
  }

  handleGoBack = () => {
    this.props.history.push(`/portal/app/admin/hallticket`)
  }

  handleVersionButton = (e, hallTicketId, userId) => {
    e.preventDefault();
    this.props.history.push(`/portal/app/admin/hallticket/version/${hallTicketId}/${userId}`)
  }

  render() {
    let displayComponent ;
    let handleUpdateHallTicketDetails = this.handleUpdateHallTicketDetails
    let handleHallTicketDownload = this.handleHallTicketDownload
    let handleVersionButton = this.handleVersionButton
    let searchCriteria = [ "roll_number","user_id", "email", "mobile", ]
    let paginationKey = this.state.searchHit + this.state.totalCount
    let userRole = this.props.user.role
    let hallticketDownloadDisable = this.state.hallticketDownloadDisable

    if(this.state.hallTicketDetails){
      displayComponent = (<tbody>
        {this.state.hallTicketDetails.map(function (hallticket) {
          let updateButtonComponent, versionButtonComponent
          if(userRole === 'admin') {
            updateButtonComponent = (<td>
              <Button onClick={((e) => handleUpdateHallTicketDetails(e, hallticket.id, hallticket.user_id))}>Update</Button>
              </td>)
          }
          else {
            updateButtonComponent = (<td>NA</td>)
          }

          if(userRole === 'admin') {
            versionButtonComponent = (<td>
              <Button onClick={((e) => handleVersionButton(e, hallticket.id, hallticket.user_id))}>Version</Button>
              </td>)
          }
          else {
            versionButtonComponent = (<td>NA</td>)
          }

          return (<tr>
            <td>{hallticket.id}</td>
            <td>{hallticket.user_id}</td>
            <td>{hallticket.user_name}</td>
            <td>{hallticket.candidate_name}</td>
            <td>{hallticket.email}</td>
            <td>{hallticket.mobile}</td>
            {updateButtonComponent}
            <td><Button disabled={hallticketDownloadDisable} onClick={((e) => handleHallTicketDownload(e, hallticket.id))}>Download</Button></td>
            {versionButtonComponent}
            <td>{hallticket.test_city}</td>
            <td>{hallticket.test_track}</td>
            <td>{hallticket.test_time_slot}</td>
            <td>{hallticket.duration}</td>
            <td>{hallticket.reporting_time}</td>
            <td>{hallticket.roll_number}</td>
            <td>{hallticket.pin_value}</td>
            <td>{hallticket.test_location}</td>
            <td>{hallticket.test_location_address}</td>
            <td>{hallticket.pincode}</td>
            <td>{hallticket.landmark}</td>
            <td>{hallticket.country_name}</td>
            <td>{hallticket.user_download_count}</td>
            <td>{hallticket.admin_download_count}</td>
            <td>{hallticket.ht_admin_download_count}</td>
          </tr>)
          })}
      </tbody>)
    }

    let ExcelFile = ReactExport.ExcelFile;
    let ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    let  ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    let exportComponent = (
        <div>
          <TextField  className='text_input' label="Export Page" autoComplete="off" name="exportPage" onChange={this.onExportInputChange} value={this.state.data.exportPage}/>
          <Button onClick={this.handleExportData}>Export</Button>
          <ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
            <ExcelSheet data={this.state.data.exportData} name="hallticket">
              <ExcelColumn label="hallticket_id" value="id"/>
              <ExcelColumn label="user_id" value="user_id"/>
              <ExcelColumn label="user_name" value="user_name"/>
              <ExcelColumn label="name" value="candidate_name"/>
              <ExcelColumn label="email" value="email"/>
              <ExcelColumn label="mobile" value="mobile"/>
              <ExcelColumn label="test_city" value="test_city"/>
              <ExcelColumn label="test_track" value="test_track"/>
              <ExcelColumn label="test_time_slot" value="test_time_slot"/>
              <ExcelColumn label="duration" value="duration"/>
              <ExcelColumn label="reporting_time" value="reporting_time"/>
              <ExcelColumn label="roll_number" value="roll_number"/>
              <ExcelColumn label="pin" value="pin_value"/>
              <ExcelColumn label="test_location" value="test_location"/>
              <ExcelColumn label="test_location_address" value="test_location_address"/>
              <ExcelColumn label="pincode" value="pincode"/>
              <ExcelColumn label="landmark" value="landmark"/>
              <ExcelColumn label="country" value="country_name"/>
              <ExcelColumn label="user_downloaded_count" value="user_download_count"/>
              <ExcelColumn label="admin_downloaded_count" value="admin_download_count"/>
              <ExcelColumn label="ht_admin_downloaded_count" value="ht_admin_download_count"/>
            </ExcelSheet>
          </ExcelFile>
        </div>
      )

    let backButtonComponent;
    if(userRole === 'admin') {
      backButtonComponent = ( 
          <GridCell span="2">
            <Button onClick={this.handleGoBack}>BACK </Button>
          </GridCell>)
    }
    else{
      backButtonComponent = ('')
    }

    return(
      <div>
        <Grid>
          <GridCell span="10">
            <Typography use="headline5"><u>Hall Ticket Details</u></Typography>
          </GridCell>
          {backButtonComponent}
          <GridCell span="12">
            <ListDivider/>
            <br/>
            <div>
              <Select 
                onChange={this.handleSearchCriteriaChange} 
                value={this.state.criteria}
                className="admin-reg-filter-section"
                placeholder="-- Search By Details --" 
              >
                {searchCriteria.map(criteria => (
                  <option value={criteria} data-name={criteria}>
                    {criteria}
                  </option>
                ))}
              </Select>
              <TextField  className='admin-reg-filter-criteria' label="Search Term" autoComplete="off" name="searchTerm" onChange={this.onInputChange} value={this.state.searchTerm}/>
              <Button className="add-opportunity" onClick={this.handleSearchQuery}>
                Search
              </Button>
              <Button className="add-opportunity" onClick={this.handleClear}>
                Clear
              </Button>
            </div>
            <StatusMessage error_msg = {this.state.searchErrorMsg}/>
            <br/>
            {exportComponent}
            <GridCell span="12">
              <table>
                <th>HallTicket ID</th>
                <th>User ID</th>
                <th>User Name</th>
                <th>Name</th>
                <th>email</th>
                <th>Mobile</th>
                <th>Update</th>
                <th>Download</th>
                <th>Version</th>
                <th>Test City</th>
                <th>Test track</th>
                <th>Test Slot Time</th>
                <th>Test duration</th>
                <th>Reporting Time</th>
                <th>Roll number</th>
                <th>Pin</th>
                <th>Test Centre</th>
                <th>Test Centre Address</th>
                <th>Pincode</th>
                <th>Land Mark</th>
                <th>Country</th>
                <th>User Downloaded Count</th>
                <th>Admin Downloaded Count</th>
                <th>Hallticket Admin Downloaded Count</th>
                {displayComponent}
              </table>
            </GridCell>
          </GridCell>
        </Grid>
        <StatusMessage error_msg = {this.state.errorMsg}/>
        <div key={paginationKey}>
          <PaginationComponent totalItems = {this.state.totalCount}
            itemsPerPage = {this.state.itemsPerPage} 
            onHandleItemsFetch = {this.fetchHallTicketDetails} />
        </div>
      </div>
    );
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHallTicketDetails);


// WEBPACK FOOTER //
// ./src/views/admin/AdminHallTicketDetails.jsx